import React, {useContext, useState} from 'react'
import UploadFile from 'components/UploadFile';
import TitledComponent from 'components/TitledComponent';
import SelectSiwzDocumentType from "./SelectSiwzDocumentType";
import SiwzService from "services/SiwzService";
import SiwzFileTable from "./SiwzFileTable";
import DemandValidationContext from "context/DemandValidationContext";
import Tr from "translations/Translations";
import PropTypes from "prop-types";

function SelectSiwzDocument(
    {
        demandId,
        disabled,
        isPublished,
    }) {

    const currentDemandValidation = useContext(DemandValidationContext);
    const [portFilesWorking, setPostFilesWorking] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState(null);
    const [configuredFiles, setConfiguredFiles] = useState(null);


    const handleSendFiles = (uploadedFiles, config) => {
        setConfiguredFiles(null);
        if(uploadedFiles.length) {
            const tab = uploadedFiles.map((x, i) => ({
                ...x,
                type: config[`item${x.originalIndex}`],
                parent: config[`parent${x.originalIndex}`],
                autopublish: config[`autopublish${x.originalIndex}`],
            }));
            setPostFilesWorking(true)
            SiwzService.send(demandId, tab, currentDemandValidation).finally(()=> setPostFilesWorking(false));
        }
    };

    const handleSubmitSelectDocumentTypes = (values) => {
        setConfiguredFiles({files: selectedFiles, config: values})
        setSelectedFiles(null);
    };

    return (
        <>
            <TitledComponent title={Tr('added_documents')}>

                {!disabled &&
                    <UploadFile
                        onUploadPopupClosed={handleSendFiles}
                        onOpenConfigureFiles={(files) => setSelectedFiles(files)}
                        configuredFiles={configuredFiles}
                        working={portFilesWorking}
                    />
                }

                <SiwzFileTable
                    demandValidationSectionId={currentDemandValidation}
                    demandId={demandId}
                    isPublished={isPublished}
                    disabled={disabled}
                />
            </TitledComponent>

            {!!selectedFiles && <SelectSiwzDocumentType
                items={selectedFiles}
                onCancel={() => setSelectedFiles(null)}
                onSubmit={handleSubmitSelectDocumentTypes}
                pickAutopublish={isPublished}
                pickParent={isPublished}
            />}
        </>
    )
}

SelectSiwzDocument.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    disabled: PropTypes.bool.isRequired,
    isPublished: PropTypes.bool.isRequired,
};

export default SelectSiwzDocument;